<template>
    <div class="CardPricing">
        <img v-if="imageUrl" :src="imageUrl" alt="Loading dump trucks" />
        <Card>
            <h4 v-if="title" class="cardTitle">{{ title }}</h4>
            <h3>
                ${{ priceArr.currPrice }} <strike>${{ priceArr.oldPrice }}</strike>
            </h3>
            <h4>{{ priceArr.perDriver }}</h4>

            <ul>
                <li v-for="(feature, index) in features" :key="index">
                    <Icon :name="feature.icon" />
                    {{ feature.description }}
                </li>
            </ul>

            <Button to="signup" class="primary lg">Get Started</Button>
            <div class="trial">30 Day Free Trial. Cancel anytime.</div>
        </Card>
    </div>
</template>

<script>

import Icon from 'vue-awesome/components/Icon';
import Card from '@/components/Card';

export default {
    name: 'CardPricing',

    components: { 
        Icon,
        Card 
    },

    props: {
        title: { 
            type: String, 
            default: '' 
        },
        imageUrl: { 
            type: String, 
            default: '' 
        },
        priceArr: { 
            type: Object, 
            default: () => ({
                currPrice: 0,
                oldPrice: 0,
                perDriver: 'Per driver / month'
            })
        },
        features: { 
            type: Array, 
            default: () => [
                { icon: 'infinity', description: 'Per driver / month' },
                { icon: 'check', description: 'Unlimited tickets & loads' },
                { icon: 'check', description: 'Administrator CMS' },
                { icon: 'check', description: 'Mobile app for drivers' },
                { icon: 'check', description: 'Generate reports' },
                { icon: 'check', description: 'Ticket alerts' },
                { icon: 'check', description: 'Constant updates' }
            ] 
        }
    },

}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.CardPricing {
    display: flex;
    margin-bottom: 60px;
    border-radius: $border-radius;
    box-shadow: $shadow-soft;
    overflow: hidden;

    h3 {
        letter-spacing: -3px;
    }

    strike {
        margin-left: 5px;
        color: $text-color-muted;
        font-size: 42px;
    }

    img {
        min-width: 0;
        object-fit: cover;

        @include breakpoint(md) {
            max-height: 200px;
        }
    }

    @include breakpoint(md) {
        flex-direction: column;
    }

    .Card {
        max-width: 360px;
        margin: 0 auto;
        text-align: center;
        border-radius: none;
        box-shadow: none;

        h3 {
            @extend %display-title;
        }

        h4 {
            font-weight: $font-weight-regular;
            margin-bottom: 30px;
        }

        ul {
            margin-bottom: 30px;
            list-style: none;
            font-size: 18px;
            text-align: left;

            li {
                display: flex;
                align-items: center;
                margin: 10px 0;
            }

            .Icon {
                width: 30px;
                margin-right: 10px;
                color: $text-color-muted;
            }
        }

        .cardTitle {
            font-weight: bold;
            font-size: 20px;
        }
    }

    .trial {
        margin-top: $grid-gutter-width;
    }

}
</style>
